

// require('../sass/style.scss');
window.$ = window.jQuery = require('jquery');
require('slick-carousel/slick/slick');
require('bootstrap');
require('lightgallery/dist/js/lightgallery-all');
require('./typeahead');
function fixedMenu() {
    var height = $(window).scrollTop();
    if (height > 5) {
        $('body #header').addClass('header--blue');
    }
    else {
        $('body #header').removeClass('header--blue');
    }
}

$(document).on('click', '#writeMessageBtn', function (e) {
    let agentId = $(this).data('agent-id');
    $('#contact .agent_id_input').val(agentId);
    let agentTitle = $(this).data('agent-title');
    $('#contact .page-section__title').html(agentTitle);
    $('#contact .agent-contact__name').html(agentTitle);
    $('#contact').removeClass('d-none');


    let contact = document.getElementById("contact").offsetTop;
    let headerHeight = document.getElementById("header").offsetHeight;
    window.scrollTo({ top: contact - headerHeight, behavior: 'smooth' });

    return false;
})

$(function () {
    var mainPage = document.getElementsByTagName('body');
    if (mainPage.length > 0) {
        fixedMenu();
        $(window).scroll(function () {
            fixedMenu();
        });
    }
});

// baner slick slider
$('#bannerItems').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 1000,
    dots: true,
    fade: true,
    autoplay: true,
    // lazyLoad: 'progressive'
    // responsive: [
    //   {
    //     breakpoint: 576,
    //     settings: {
    //       slidesToShow: 1,
    //       prevArrow: '',
    //       nextArrow: ''
    //     }
    //   }
    // ]
});

//   $('.baner-items').on('lazyLoaded', function (e, slick, image, imageSource) {
//     image.parents('.baner__item').css('background-image','url("'+imageSource+'")');
//     image.remove();
//  });

!function (window) {
    var $q = function (q, res) {
        if (document.querySelectorAll) {
            res = document.querySelectorAll(q);
        } else {
            var d = document
                , a = d.styleSheets[0] || d.createStyleSheet();
            a.addRule(q, 'f:b');
            for (var l = d.all, b = 0, c = [], f = l.length; b < f; b++)
                l[b].currentStyle.f && c.push(l[b]);

            a.removeRule(0);
            res = c;
        }
        return res;
    }
        , addEventListener = function (evt, fn) {
            window.addEventListener
                ? this.addEventListener(evt, fn, false)
                : (window.attachEvent)
                    ? this.attachEvent('on' + evt, fn)
                    : this['on' + evt] = fn;
        }
        , _has = function (obj, key) {
            return Object.prototype.hasOwnProperty.call(obj, key);
        }
        ;

    function loadImage(el, fn) {
        var img = new Image()
            , src = el.getAttribute('data-src');
        img.onload = function () {
            if (!!el.parent)
                el.parent.replaceChild(img, el)
            else
                el.src = src;

            fn ? fn() : null;
        }
        img.src = src;
    }

    function elementInViewport(el) {
        var bounding = el.getBoundingClientRect();
        var myElementHeight = el.offsetHeight;
        var myElementWidth = el.offsetWidth;

        if (bounding.top >= -myElementHeight
            && bounding.left >= -myElementWidth
            && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth
            && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) {

            return true;
        } else {

            return false;
        }
    }

    var images = new Array()
        , query = $q('img.lazy')
        , processScroll = function () {
            for (var i = 0; i < images.length; i++) {
                if (elementInViewport(images[i])) {
                    loadImage(images[i], function () {
                        images.splice(i, i);
                    });
                }
            };
        }
        ;
    // Array.prototype.slice.call is not callable under our lovely IE8
    for (var i = 0; i < query.length; i++) {
        images.push(query[i]);
    };

    processScroll();
    addEventListener('scroll', processScroll);

}(this);

// $('#our-team-slider').slick({
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   arrows: true,
//   infinite: true,
//   speed: 1000,
//   dots: true,
//   fade: true,
//   autoplay: true,
// });

$('#our-team-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 500,
    dots: true,
    fade: false,
    responsive: [
        {
            breakpoint: 1500,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 791,
            settings: {
                slidesToShow: 1,
                dots: false
            }
        }
    ]
    // autoplay: true
});

$('#similarOffers').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 500,
    dots: true,
    fade: false,
    responsive: [
        {
            breakpoint: 1500,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 791,
            settings: {
                slidesToShow: 1,
                dots: false
            }
        }
    ]
});


let categoriesObserverOptions = {
    root: null,
    rootMargin: '150px',
    threshold: 0
}

let categoriesIsShown = false;

let observer = new IntersectionObserver(elements => {
    for (let el of elements) {
        if (el.isIntersecting && !categoriesIsShown) {
            categoriesIsShown = true;
            $('.search-category__right').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                infinite: true,
                speed: 500,
                dots: true,
                fade: false,
                autoplay: false,
                responsive: [
                    {
                        breakpoint: 791,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,

                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: false,
                            arrows: true,
                        }
                    }
                ]
            });
        }
    }
}, categoriesObserverOptions);

if (document.querySelector(".search-category__right")) {
    if (document.querySelector("body.page-home")) {
        observer.observe(document.querySelector(".search-category__right"));
    }
}



$('.offerMainPage').slick({
    lazyLoad: 'ondemand',
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 500,
    dots: false,
    fade: false,
    autoplay: false,

    responsive: [
        {
            breakpoint: 1500,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 791,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                //   arrows: false
            }
        }
    ]
});

// advantages
$('.advantages').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 1000,
    dots: true,
    autoplay: false,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 1,
                arrows: false,
                dots: false
            }
        }
    ]
});

// show hide collapse button
$('.stats__more').click(function () {
    if ($('#collapseExample').hasClass('show')) {
        $('.stats__more').text('Rozwiń')
    } else {
        $('.stats__more').text('Zwiń')
    }
});

//smoth scroll
$(".smooth a[href^='#']").click(function (event) {
    event.preventDefault();

    var location = $(this.hash);
    var offset = 0;
    var speed = 1200;

    $("html,body").animate({
        scrollTop: location.offset().top - offset
    }, speed);
    return false
});

// mobile menu

$('#mobileMenu label').click(function () {
    if ($('.mobile-menu').hasClass('show')) {
        $('.mobile-menu').removeClass('show');
        $('body').removeClass('mobile-menu-is-open');

    } else {
        $('.mobile-menu').addClass('show');
        $('body').addClass('mobile-menu-is-open');
    }


    //   $('#mobileMenu').hide();
    $('.search-menu').hide();
});



// offer sort
$(function () {
    $('#sort-offer-button').click(function () {
        $('#sort-offer-menu').toggleClass('dblock');
    });

    $(this).find('#sort-offer-menu a').click((function (e) {
        e.preventDefault();
        $('[name="sort"]').val($(this).data('id'));
        $('#formListSort').submit();
    }));


    let date = new Date();
    date.setTime(date.getTime() + (180 * 24 * 60 * 60 * 1000));
    $('.offer-filters__filter--grid').click(function (e) {
        document.cookie = "offers_list=grid;expires=" + date.toGMTString() + ";path=/;"
        $('.offer-filters__filter').removeClass('active');
        $(this).addClass('active');
        $('.offers__wrapper').removeClass('offers__wrapper--row');
    });



    $('.offer-filters__filter--list').click(function (e) {
        document.cookie = "offers_list=row;expires=" + date.toGMTString() + ";path=/;"
        $('.offer-filters__filter').removeClass('active');
        $(this).addClass('active');
        $('.offers__wrapper').addClass('offers__wrapper--row');
    });
});


// NOTATNIK
$(document).ready(function () {
    notatnikIconControl();
    numbernotepad(0);
});

function notatnikIconControl() {
    $('body').on('click', '.notepadAdd', function (e) {
        e.stopPropagation();
        var tab = $(this).data('rel').split('_');
        var id = tab[1];
        DodajDoNotatnika(id, $(this));
        getSidebarNotepadOffers();
        return false;
    });

    $('body').on('click', '.notepadRemove', function (e) {
        e.stopPropagation();
        var tab = $(this).data('rel').split('_');
        var id = tab[1];
        UsunZNotatnika(id, $(this));
        return false;
    });

    $("body").on({
        click: function (e) {
            e.stopPropagation();
            var id = $(this).data("id");
            if ($("a.notepadRemove[data-rel='oferta_" + id + "']").length) {
                UsunZNotatnika(id, $("a.notepadRemove[data-rel='oferta_" + id + "']"), $(this));
            }
            else {
                UsunZNotatnika(id, $(this));
            }
        }
    }, '#notepad-box .notepad-offer .remove');
}

function numbernotepad(animateButton) {
    var c = readCookie("notatnik");
    if (c === null || c === "") {
        $('.notepadLink').fadeOut();
    } else {
        $('.notepadLink').fadeIn();
    }
}

function DodajDoNotatnika(Id, el) {

    console.log('dodaj do notatnika');
    var c = readCookie("notatnik");

    if (c === null) {
        c = Id + ",";
    }
    else if ($.inArray(Id, c.split(",")) === -1) {
        c += Id + ",";
    }

    eraseCookie("notatnik");
    createCookie("notatnik", c, 31);

    $(el).attr('title', $(el).attr('data-remove-text'));
    $(el).addClass('notepadRemove');
    $(el).removeClass('notepadAdd');
    //$(el).parent().find(".notepadRemove").show();
    //$(el).hide();
    $.jGrowl(infoText['dodano-do-notatnika'], { life: 800, position: 'bottom-right' });
    numbernotepad(1);
}

function UsunZNotatnika(Id, el) {
    console.log('usun z notatnika');
    var c = readCookie("notatnik");
    if (c === null) c = "";
    if (c.indexOf(Id + ",") > -1) {
        c = c.replace(Id + ",", "");
    }
    eraseCookie("notatnik");
    createCookie("notatnik", c, 31);

    $(el).attr('title', $(el).attr('data-add-text'));
    $(el).removeClass('notepadRemove');
    $(el).addClass('notepadAdd');

    if (el) {
        //el.parent().find(".notepadAdd").show();
        //el.hide();

        if (el.hasClass('notepad')) {
            el.parents('.offer').slideUp(500, function () {
                el.parents('.offer').remove();
                var offersCount = $('.offersListHolder .offer').length;
                if (!offersCount) {
                    if ($('.offersListHolder').data('notepadredirect')) {
                        window.location.replace($('.offersListHolder').data('notepadredirect'));
                    }
                    else {
                        location.reload();
                    }

                }
            });


        }
    }

    if ($("#notepad-box .notepad-offer").length > 1) {
        getSidebarNotepadOffers();
    }
    else {
        $("#notepad-box .add-padding").fadeOut("normal", function () {
            $(this).remove();
        });
    }

    $.jGrowl(infoText['usunieto-z-notatnika'], { life: 800, position: 'bottom-right' });
    numbernotepad(1);

    if (c == '') {
        $("#offers-list-map").css('display', 'none');
        $('.notepad .title').toggleClass('empty');
    }
}


function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

/*
 * Oferty w notatniku (w sidebarze)
 */
function getSidebarNotepadOffers() {
    if ($("#notepad-box").length) {
        $.ajax({
            url: "handler/getSidebarNotepadOffers/",
            dataType: "json"
        }).done(function (result) {
            try {
                if (result.status === 'ok' && result.result) {
                    $("#notepad-box").html(result.result);
                }
            }
            catch (err) {
                //console.log("getSidebarNotepadOffers err = " + err);
            }
        });
    }
}


// $('.offer-card').click(function (e) {
//     let url = $(this).data('url');
//     window.location = url;
// });

$('#blog-gallery').lightGallery();
$('[data-action="share"]').click(function (e) {
    e.preventDefault();
    $('.share-box').toggle();
});

$(function () {

    // Close popup
    $('#popup-close').click(function () {
        $('#popup').css('display', 'none');
    });

    // breadcrumbs
    const breadcrumbsList = document.querySelector(".breadcrumbs__list")
    if (breadcrumbsList) {
        breadcrumbsList.scrollTo(0, 0);
        if (breadcrumbsList != 'undefined') {
            initBreadcrumbs(breadcrumbsList);
            breadcrumbsList.addEventListener("scroll", (event) => {
                initBreadcrumbs(breadcrumbsList);
            });
        }
    }
});

function initBreadcrumbs(breadcrumbsList) {
    const breadcrumbs = document.querySelector('.breadcrumbs')
    if (breadcrumbsList.scrollLeft >= 5) {
        breadcrumbs.classList.add('breadcrumbs--overflow-left')
    } else {
        breadcrumbs.classList.remove('breadcrumbs--overflow-left')
    }

    if (breadcrumbsList.scrollWidth - breadcrumbsList.offsetWidth - breadcrumbsList.scrollLeft >= 5) {
        breadcrumbs.classList.add('breadcrumbs--overflow-right')
    } else {
        breadcrumbs.classList.remove('breadcrumbs--overflow-right')
    }
}




$('#input-location').on('focus', function () {
    $('label[for="input-location"]').hide();
}).on('blur', function () {
    if ($('#input-location').val() === '') {
        $('label[for="input-location"]').show();
    }
});


$('.mobile-menu__sub-menu-toggle').click(function (e) {
    e.preventDefault();
    if ($(this).parent().children('.mobile-menu__sub-menu-toggle-checkbox').is(":checked")) {
        $(this).parent().children('.mobile-menu__sub-menu-toggle-checkbox').prop('checked', false)
    } else {
        $(this).parent().children('.mobile-menu__sub-menu-toggle-checkbox').prop('checked', false)
        $(this).parent().children('.mobile-menu__sub-menu-toggle-checkbox').prop('checked', true);
    }
});

$(function () {
    $('#searchBySymbol').submit(function (e) {
        var url = "/handler/searchOfferByNumber";
        $.ajax({
            headers:
                { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            type: 'POST',
            url: url,
            cache: false,
            dataType: 'json',
            data: $(this).serialize(),
            success: function (data) {
                data = eval(data);
                if (typeof data['link'] !== "undefined" && data['link']) {
                    document.location = data['link'];
                }
                else {
                    $('#offerNotFound .modal-body').html(data['error-msg']);
                    $('#offerNotFound').modal('show')
                }
            }
        });
        return false;
    });

    $(document).on("click", ".social-share-button", function (event) {
        var location = $(event.target).attr('data-loc');
        if (typeof location == 'undefined') {
            location = $(event.target).parents('[data-loc]').attr('data-loc');
        }
        window.open(location, "_blank");
    });


    $(document).on("click", ".social-share-button", function (event) {
        var location = $(event.target).attr('data-loc');
        if (typeof location == 'undefined') {
            location = $(event.target).parents('[data-loc]').attr('data-loc');
        }
        window.open(location, "_blank");
    });

});

